import { motion } from "framer-motion";
import { Utensils, BedDouble, Wifi, ShieldCheck } from "lucide-react";

export default function About() {
  const features = [
    {
      icon: <Utensils className="text-yellow-400 w-14 h-14" />,
      title: "Delicious Food",
      desc: "Savor freshly prepared meals made with local ingredients and love.",
      amharic: "በጥንቃቄ የተዘጋጁ ጣፋጭ ምግቦችን በፍቅር ይመገቡ።",
    },
    {
      icon: <BedDouble className="text-yellow-400 w-14 h-14" />,
      title: "Comfortable Rooms",
      desc: "Stay in elegant, peaceful rooms designed for relaxation and rest.",
      amharic:
        "ለዕረፍት እና ምቾት የተስማሙ ከዝቅተኛ እስከ ከፍተኛ ዋጋ ያላችውን ክፍሎች ውስጥ ታገኛላችሁ።",
    },
    {
      icon: <Wifi className="text-yellow-400 w-14 h-14" />,
      title: "Free Wi-Fi",
      desc: "Enjoy unlimited, high-speed internet access during your stay.",
      amharic: "በእያንዳንዱ room ፈጣን እና ነፃ ኢንተርኔት ይጠቀሙ።",
    },
    {
      icon: <ShieldCheck className="text-yellow-400 w-14 h-14" />,
      title: "Safe & Secure",
      desc: "Your comfort and safety are protected by 24/7 security systems.",
      amharic:
        "ደህንነትዎ በ24/7 በአስተማማኝ ሁኔታ በደህንነት ካሜራ እና በሰው ሃይል የተጠበቀ ነው።",
    },
  ];

  return (
    <motion.section
      id="about"
      className="py-24 bg-[#fff8e7] text-black font-[Poppins]" // ← light golden background
      initial={{ opacity: 0, y: 80 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
      viewport={{ once: true }}
    >
      <div className="max-w-6xl mx-auto px-6 text-center">
        <h2 className="text-5xl font-bold text-yellow-600 mb-6 tracking-tight font-[Playfair_Display]">
          About Ferej Hotel
        </h2>
        <p className="text-xl text-gray-800 max-w-3xl mx-auto mb-16 leading-relaxed">
          At{" "}
          <span className="text-yellow-700 font-semibold font-[Playfair_Display]">
            Ferej Hotel
          </span>
          , we combine simplicity, comfort, and genuine hospitality.
          Every stay with us is designed to give you peace, joy, and unforgettable memories.
          <br />
          <span className="text-gray-600 italic text-lg">
            በ
            <span className="text-yellow-700 font-semibold font-[Playfair_Display]">
              ፈረጅ ሆቴል
            </span>{" "}
            ለእርስዎ የሚያስደስት አገልግሎት እናቀርባለን።
          </span>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              className="bg-black text-white rounded-3xl shadow-2xl border border-yellow-300/30 hover:border-yellow-400 hover:shadow-yellow-400/40 transform hover:-translate-y-3 transition-all duration-500 p-10 flex flex-col items-center justify-center space-y-5"
              whileHover={{ scale: 1.05 }}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              {feature.icon}
              <h3 className="text-2xl font-semibold text-yellow-400 font-[Playfair_Display] text-center">
                {feature.title}
              </h3>
              <p className="text-gray-200 text-lg leading-relaxed font-[Poppins] text-center">
                {feature.desc}
              </p>
              <p className="text-gray-400 text-sm italic font-[Poppins] text-center">
                {feature.amharic}
              </p>
            </motion.div>
          ))}
        </div>
      </div>

      <style>
        {`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600&family=Poppins:wght@400;500;600&display=swap');
        `}
      </style>
    </motion.section>
  );
}
